import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AppProvider } from './AppContext';
import App from './App';
import { startSync } from './lib/offline';
import { getToken } from './lib/api';

import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/doc.css';

// Replay anything queued while offline, then keep watching for reconnects.
startSync(getToken);

createRoot(document.getElementById('app')).render(
  <React.StrictMode>
    {/*
      BrowserRouter, not HashRouter. The previous app used hash routing while
      the emails it sent linked to real paths like /p/<token> — so every
      proposal, agreement and invoice link a customer clicked redirected
      straight to the login screen. Path routing is what makes those links
      resolve; the server already serves index.html for any non-/api path.
    */}
    <BrowserRouter>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

// Service worker registration is owned by UpdatePrompt, so the app can offer
// a reload rather than swapping the page out mid-edit.
